import * as R from 'ramda';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
//////////////////////////////////////////////////

export const getRateFromSharedAccessAndFuelPrices = (access) => {
  const { rate, district, timePeriod, useFuelIndex, fuelIndexVariables } = access;

  const { fuelPrice, fuelPricesInfo } = R.propOr({}, timePeriod, G.getItemFromWindow('amousFuelIndexInfo'));

  let rateToUse = rate;

  let fuelIndexInfo = null;

  const districtFuelPrice = R.path([district], fuelPrice);

  if (G.isAllTrue(G.isTrue(useFuelIndex), G.isArray(fuelIndexVariables), G.isNotNilAndNotEmpty(districtFuelPrice))) {
    fuelIndexVariables.forEach((item) => {
      const { rate, valueTo, valueFrom } = item;

      if (R.and(R.gte(districtFuelPrice, valueFrom), R.lt(valueTo))) {
        rateToUse = rate;

        fuelIndexInfo = {
          district,
          timePeriod,
          rate: rateToUse,
          price: districtFuelPrice,
          priceDate: G.getPropFromObject('priceDate', fuelPricesInfo),
        };
      }
    });
  }

  return { fuelIndexInfo, rate: rateToUse };
};

export const mapConfiguredAccessorials = (access, items, source) => R.map((item) => {
  const {
    guid,
    name,
    types,
    currency,
    quantity,
    rateUnit,
    rateType,
    deduction,
    matrixUom,
    matrixType,
    useFuelIndex,
    freeDistance,
    assessorialGuid,
    matrixVariables,
    transportationMode,
  } = item;

  const accessorialConfig = R.find(
    R.propEq(assessorialGuid, GC.FIELD_ORIGINAL_CONFIG_GUID), R.or(access, []),
  ) || {};

  const { fuelRelated } = accessorialConfig;

  const { rate, fuelIndexInfo } = getRateFromSharedAccessAndFuelPrices(item);

  return {
    ...R.pick([GC.FIELD_NON_TAXABLE, GC.FIELD_ADVANCE_PAYMENT], accessorialConfig),
    rate,
    guid,
    types,
    currency,
    quantity,
    rateType,
    rateUnit,
    deduction,
    matrixUom,
    matrixType,
    freeDistance,
    fuelIndexInfo,
    assessorialGuid,
    matrixVariables,
    accessorialSource: source,
    originalConfigGuid: assessorialGuid,
    fuelRelated: R.or(useFuelIndex, fuelRelated),
    storedValue: R.or(name, accessorialConfig.storedValue),
    displayedValue: R.or(name, accessorialConfig.displayedValue),
    [GC.FIELD_SHARED_ASSESSORIAL_GUID]: source === 'shared' ? guid : null,
    [GC.FIELD_TRANSPORTATION_MODE_GUID]: G.getDropdownOptionGuidFromObject(transportationMode),
  };
}, R.or(items, []));

export const setAccessorialsFromResponseToChargeUse = (access, shared) => (
  R.concat(mapConfiguredAccessorials(access, shared, 'shared'), access)
);
